
import {ImgCount} from '@/components';
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {OrderProxy} from '@/http/RequestProxy.class';
import store from '@/store/index';

export default {
name: 'apartment',
directives: {
TransferDom,
},
components: {
FlexboxItem,
Flexbox,
ImgCount,
Previewer,
},
props: {
data: Object,
refName: String,
params: Object,
},
data(){
return {

showAllRooms: false,
previewList: [],  // 图片数组
options: {        // 图片预览组件相关属性设置
getThumbBoundsFn (index) {
let thumbnail = document.querySelectorAll('.img-position-center')[index];
let pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
let rect = thumbnail.getBoundingClientRect();

return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
},
},
};
},
computed: {
currency_code(){
return window.localStorage.getItem('currency_code');
},

lanType(){
return +window.localStorage.getItem('lan_type');
},
},
mounted(){
if(this.data.banner.length > 0){
this.formatPreview();
}
},
methods: {
/** 查看房型 */
onViewRoom(ev, isPlan = false, planIdx = 0){

this.$store.dispatch('setRoomTypeData', this.data);
this.$router.push({
name: 'plan-detail',
params: {plan_index: planIdx},
query: this.params,
});
},

/** 预订酒店 */
onGotoBook(ev, roomTypeId, planId, roomPerson){

new OrderProxy().checkLoginStatus()
.then(resp => {
if(resp.data.is_login){
this.$emit('on-book', {room_type_id: roomTypeId, booking_plan_id: planId, room_person: roomPerson});
}else{
const local = window.localStorage;
const curLocal = encodeURIComponent(window.location.href) + `?currency_code=${local.currency_code}&lan_type=${local.lan_name}`;

window.location.href = `${store.state.WAP_HOST}login.php?redirect_url=${curLocal}`;
}
});
ev.stopPropagation();
},

/** 展开房型列表 */








onShowMoreRooms(){
this.showAllRooms = true;
},

/** 预览房型图片 */
onPreviewImg(){
this.$refs.previewer.show(0);
},

/** 图片地址处理 */
formatPreview(){
let temp = [];

this.data.banner.forEach(it => {
temp.push({src: it.img_url});
});

this.previewList = temp;
},

/** 显示条件取消内容 */
onShowCancelCondition(cancelContent){
this.$vux.alert.show({
content: cancelContent,
buttonText: this.$i18n.t('hotel.SHUT_DOWN'),
});
},
},
};



// WEBPACK FOOTER //
// ./src/views/hotel-detail/components/Apartment.vue